import React, { createContext, useState } from "react";

// Create the context
export const AccountContext = createContext();

// Create the provider component
export const AccountProvider = ({ children }) => {
  const [whatAccount, setWhatAccount] = useState(null);
  const [clientAccounts, setAccounts] = useState([]);
  const [googleCategories, setGoogleCategories] = useState([]);
  const [userAccounts, setUserAccounts] = useState([]);
  const [actionButtons, setActionButtons] = useState([]);
  const [activeClient, setActiveClient] = useState([]);
  const [activeOutlet, setActiveOutlet] = useState([]);
  const [masked, setMasked] = useState(false);
  const [originalID, setOriginalID] = useState('');
  const [myAccount, setMyAccount] = useState([]);
  const [userEditAccount, setUserEditAccount] = useState([]);
  const [followUpArray, setFollowUpArray] = useState([]); // used for the LGO Follo Up
  const [returnToLastLink, setReturnToLastLink] = useState(''); // used for the LGO Follo Up

  // Updaters
  const updateWhatAccount = (account) => setWhatAccount(account);
  const updateClientAccounts = (newAccounts) => setAccounts(current => {
    const next = typeof newAccounts === 'function' ? newAccounts(current) : newAccounts;
    return Array.isArray(next) ? next : current;
  });
  const updateGoogleCategories = (categories) => setGoogleCategories(current => Array.isArray(categories) ? categories : current);
  const updateUserAccounts = (users) => setUserAccounts(current => Array.isArray(users) ? users : current);
  const updateActionButtons = (users) => setActionButtons(users);
  const updateActiveClient = (users) => setActiveClient(users);
  const updateActiveOutlet = (users) => setActiveOutlet(users);
  const updateMasked = (boolean) => setMasked(boolean);
  const updateOriginalID = (boolean) => setOriginalID(boolean);
  const updateMyAccount = (lgo) => setMyAccount(lgo);
  const updateUserEditAccount = (user) => setUserEditAccount(user);
  const updateFollowUpArray = (array) => setFollowUpArray(array);
  const updateReturnToLastLink = (link) => setReturnToLastLink(link);

  return (
    <AccountContext.Provider
      value={{
        whatAccount,
        clientAccounts,
        googleCategories,
        userAccounts,
        actionButtons,
        activeClient,
        activeOutlet,
        masked,
        userEditAccount,
        originalID,
        myAccount,
        followUpArray,
        returnToLastLink,
        updateWhatAccount,
        updateClientAccounts,
        updateGoogleCategories,
        updateUserAccounts,
        updateActionButtons,
        updateActiveClient,
        updateActiveOutlet,
        updateMasked,
        updateOriginalID,
        updateUserEditAccount,
        updateMyAccount,
        updateFollowUpArray,
        updateReturnToLastLink,
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};
